import React, { useState, useRef, useEffect } from "react";
import { useCountry } from './../CountryContext';
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
const Dropdown = ({ type, value, options, onSelect, countryValue }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownMenuRef = useRef(null);
  const contentRef = useRef(null);
  const thumbRef = useRef(null);
  const [thumbHeight, setThumbHeight] = useState(20);
  const [scrollTop, setScrollTop] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});

  // Define all possible options
  const allOptions = {
     
      CROPS: [
          { id: "african-night-shade", name: "African Night Shade", value: "african-night-shade" },
          { id: "alovera", name: "Alovera", value: "alovera" },
          { id: "avocados", name: "Avocados", value: "avocados" },
          { id: "apple", name: "Apple", value: "apple" },
          { id: "bananas", name: "Bananas", value: "bananas" },
          { id: "baobab", name: "Baobab", value: "baobab" },
          { id: "beans", name: "Beans", value: "beans" },
          { id: "beetroot", name: "Beetroot", value: "beetroot" },
          { id: "black-nightshade", name: "Black Nightshade", value: "black-nightshade" },
          { id: "cabbage", name: "Cabbage", value: "cabbage" },
          { id: "capsicum", name: "Capsicum", value: "capsicum" }
      ],
      LIVESTOCK: [
          { id: "bees", name: "Bees", value: "bees" },
          { id: "cattle-dairy", name: "Cattle - Dairy", value: "cattle-dairy" },
          { id: "fish", name: "Fish", value: "fish" },
          { id: "catfish", name: "Catfish", value: "catfish" }
      ],
      FOREST: [
          { id: "bamboo", name: "Bamboo", value: "bamboo" },
          { id: "blue-gum", name: "Blue Gum", value: "blue-gum" }
      ]
  };

  // Get the correct options based on dropdown type
  const dropdownOptions = allOptions[type] || options || [];

  const capitalizeWords = (str) => {
      if (!str) return "";
      return str
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(" ");
  };

  const getDisplayValue = () => {
      if (value) {
          if (type === "COUNTRY") return value.name || "-";
          return value.name || value.value || "-";
      }
      return "-";
  };

  const getHeaderTitle = () => {
      switch (type) {
          case "COUNTRY":
              return "Countries";
          case "REGION":
              return "Regions";
          case "DISTRICT":
              return "Districts";
          case "MUNICIPALITY":
              return "Municipalities";
          case "SMMEs":
              return "SMMEs";
          case "VALUE CHAIN":
              return "Value Chains";
          case "PROJECT":
              return "Projects";
          case "USER TYPE":
              return "User Types";
          case "SERVICES":
              return "Services";
          case "CROPS":
              return "Crops";
          case "LIVESTOCK":
              return "Livestock";
          case "FOREST":
              return "Forest";
          default:
              return "Select Option";
      }
  };

  const toggleItemSelection = (itemId) => {
      setSelectedItems(prev => ({
          ...prev,
          [itemId]: !prev[itemId]
      }));
  };

  const renderRegularItems = () => {
      return dropdownOptions?.map((option, index) => (
          <li
              key={index}
              className={`group flex items-center justify-between px-3 py-2 text-sm cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                  selectedItems[option.id] ? "bg-[#2E453D]" : ""
              }`}
          >
              <span 
                  className="text-white"
                  onClick={(e) => {
                      e.stopPropagation();
                      onSelect(option);
                      setIsOpen(false);
                  }}
              >
                  {option.name || option.value}
              </span>
              <button 
                  onClick={(e) => {
                      e.stopPropagation();
                      toggleItemSelection(option.id);
                  }}
              >
                  {selectedItems[option.id] ? <SelectedIcon /> : <UnselectedIcon />}
              </button>
          </li>
      ));
  };

  const renderGroupedItems = () => {
    return (
      <div className="mb-2">
        {/* Always show all sections */}
        <h4 className="text-white font-bold px-3 py-1 bg-[#2E453D]/50">CROPS</h4>
        <ul>
          {allOptions.CROPS.map((item, index) => (
            <li
              key={`crop-${index}`}
              className={`group flex items-center justify-between px-3 py-2 text-sm text-white cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                selectedItems[item.id] ? "bg-[#2E453D]" : ""
              }`}
            >
              <span 
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect(item);
                  setIsOpen(false);
                }}
              >
                {item.name}
              </span>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  toggleItemSelection(item.id);
                }}
              >
                {selectedItems[item.id] ? <SelectedIcon /> : <UnselectedIcon />}
              </button>
            </li>
          ))}
        </ul>
  
        <h4 className="text-white font-bold px-3 py-1 bg-[#2E453D]/50 mt-2">LIVESTOCK</h4>
        <ul>
          {allOptions.LIVESTOCK.map((item, index) => (
            <li
              key={`livestock-${index}`}
              className={`group flex items-center justify-between px-3 py-2 text-sm text-white cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                selectedItems[item.id] ? "bg-[#2E453D]" : ""
              }`}
            >
              <span 
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect(item);
                  setIsOpen(false);
                }}
              >
                {item.name}
              </span>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  toggleItemSelection(item.id);
                }}
              >
                {selectedItems[item.id] ? <SelectedIcon /> : <UnselectedIcon />}
              </button>
            </li>
          ))}
        </ul>
  
        <h4 className="text-white font-bold px-3 py-1 bg-[#2E453D]/50 mt-2">FOREST</h4>
        <ul>
          {allOptions.FOREST.map((item, index) => (
            <li
              key={`forest-${index}`}
              className={`group flex items-center justify-between px-3 py-2 text-sm text-white cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                selectedItems[item.id] ? "bg-[#2E453D]" : ""
              }`}
            >
              <span 
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect(item);
                  setIsOpen(false);
                }}
              >
                {item.name}
              </span>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  toggleItemSelection(item.id);
                }}
              >
                {selectedItems[item.id] ? <SelectedIcon /> : <UnselectedIcon />}
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const UnselectedIcon = () => (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8.5" cy="8.5" r="8" fill="#D9D9D9" stroke="none"/>
    </svg>
  );
  
  const SelectedIcon = () => (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8.5" cy="8.5" r="8" fill="#2E453D" stroke="#FFBD26"/>
      <path d="M5 8.5L7.5 11L12 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  const handleScroll = () => {
    if (!contentRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
    setScrollTop(scrollTop);
    
    const thumbH = Math.max(
      (clientHeight / scrollHeight) * clientHeight,
      20
    );
    setThumbHeight(thumbH);
  };

  const handleTrackClick = (e) => {
    if (!contentRef.current || !thumbRef.current) return;
    const trackRect = e.currentTarget.getBoundingClientRect();
    const thumbOffset = e.clientY - trackRect.top - thumbHeight / 2;
    const scrollPercentage = thumbOffset / (trackRect.height - thumbHeight);
    contentRef.current.scrollTop =
      scrollPercentage * (contentRef.current.scrollHeight - contentRef.current.clientHeight);
  };

  const handleThumbMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
    
    const startY = e.clientY;
    const startScrollTop = scrollTop;
    
    const handleMouseMove = (e) => {
      if (!isDragging || !contentRef.current) return;
      const deltaY = e.clientY - startY;
      const trackHeight = contentRef.current.clientHeight - thumbHeight;
      const scrollDelta = (deltaY / trackHeight) * contentRef.current.scrollHeight;
      contentRef.current.scrollTop = startScrollTop + scrollDelta;
    };
    
    const handleMouseUp = () => {
      setIsDragging(false);
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
    
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownMenuRef.current && !dropdownMenuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (contentRef.current) {
      handleScroll();
    }
  }, [isOpen, options]);

  return (
      <div className="relative md:mr-4 mr-2" ref={dropdownMenuRef}>
      <button
        className={`relative xl:w-[205px] lg:w-[160px] md:w-[100px] w-[70px] h-[20px] md:h-[53px] bg-[#2E453D] text-white flex justify-between items-center text-[8px] md:text-[17px] px-[2px] rounded-[4px] truncate`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={`whitespace-normal break-words font-normal leading-[0.90] text-center capitalize w-full ${
          getDisplayValue() === "-" ? "text-gray-400" : ""
        }`}>
          {capitalizeWords(getDisplayValue())}
        </span>
        
        <span className="absolute bottom-[1px] right-3 text-[6px] md:text-[8px] text-white">
          {(type === "COUNTRY" && value?.code) || 
           (type === "REGION" && value?.value) || 
           (type === "DISTRICT" && value?.value) || 
           (type === "SMMEs" && value?.value) || 
           '-'}
        </span>
        
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751799445/Expand_down_light_syoynq.png"
          alt="expand"
          className="absolute bottom-2 right-2 w-2 h-2 md:w-5 md:h-5"
        />
      </button>

   
      <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.2, ease: "easeInOut" }}
                        className="bg-[#2E453D]/80 rounded-b-[5px] overflow-x-auto backdrop-blur-sm absolute top-full mt-1 left-0 w-full z-50 md:w-[205px]"
                    >
                        <div className="px-3 py-2">
                            <div className="flex items-center justify-between mb-2">
                                <h3 className="text-white text-sm font-semibold">
                                    {getHeaderTitle()}
                                </h3>
                                <img 
                                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750628487/Export_light_kuxwb6.png" 
                                    alt="Export icon"
                                    className="w-4 h-4 ml-2 cursor-pointer"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsOpen(false);
                                    }}
                                />
                            </div>
                            <div className="custom-scroll-area max-h-[200px]">
                                <div
                                    className="custom-scroll-content"
                                    ref={contentRef}
                                    onScroll={handleScroll}
                                >
                                    <ul className="space-y-2">
                                        {type === "CROPS" || type === "LIVESTOCK" || type === "FOREST"
                                            ? renderGroupedItems()
                                            : renderRegularItems()}
                                    </ul>
                                </div>
                                {/* ... scroll track code ... */}
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
    </div>
  );
};
const contactData = [
  {
    name: "Tsepo Dhlamini",
    id: "FN02701001ABA123456",
    mobile: "+270702157000",
    email: "tsepod@email.com",
    location: "17 Farmers Rd, Gauteng",
        image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698105/image_esfpty.png"

  },
  {
    name: "Lerato Mbeki",
    id: "FN02701001ABA123457",
    mobile: "+270702157001",
    email: "leratom@email.com",
    location: "18 Vineyard St, Western Cape",
       image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "James Khumalo",
    id: "FN02701001ABA123458",
    mobile: "+270702157002",
    email: "jamesk@email.com",
    location: "19 Orchard Lane, Limpopo",
      image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Nomvula Nkosi",
    id: "FN02701001ABA123459",
    mobile: "+270702157003",
    email: "nomvulan@email.com",
    location: "20 Harvest Ave, Mpumalanga",
      image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Sipho Zwane",
    id: "FN02701001ABA123460",
    mobile: "+270702157004",
    email: "siphoz@email.com",
    location: "21 Cornfield Rd, Free State",
      image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Amahle Dlamini",
    id: "FN02701001ABA123461",
    mobile: "+270702157005",
    email: "amahled@email.com",
    location: "22 Wheat St, North West",
      image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Thando Mthembu",
    id: "FN02701001ABA123462",
    mobile: "+270702157006",
    email: "thandom@email.com",
    location: "23 Olive Grove, Eastern Cape",
       image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Bongani Ndlovu",
    id: "FN02701001ABA123463",
    mobile: "+270702157007",
    email: "bonganin@email.com",
    location: "24 Apple Orchard, KwaZulu-Natal",
       image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Nomsa Vilakazi",
    id: "FN02701001ABA123464",
    mobile: "+270702157008",
    email: "nomsav@email.com",
    location: "25 Peach Tree, Northern Cape",
       image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Mandla Cele",
    id: "FN02701001ABA123465",
    mobile: "+270702157009",
    email: "mandlac@email.com",
    location: "26 Berry Farm, Gauteng",
        image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Zanele Ngwenya",
    id: "FN02701001ABA123466",
    mobile: "+270702157010",
    email: "zanele@email.com",
    location: "27 Citrus Valley, Western Cape",
      image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Sibusiso Mkhize",
    id: "FN02701001ABA123467",
    mobile: "+270702157011",
    email: "sibusisom@email.com",
    location: "28 Grape Vine, Limpopo",
       image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Nthabiseng Molefe",
    id: "FN02701001ABA123468",
    mobile: "+270702157012",
    email: "nthabisengm@email.com",
    location: "29 Tomato Field, Mpumalanga",
       image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Kagiso Botha",
    id: "FN02701001ABA123469",
    mobile: "+270702157013",
    email: "kagisob@email.com",
    location: "30 Potato Farm, Free State",
       image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Lungile Van Niekerk",
    id: "FN02701001ABA123470",
    mobile: "+270702157014",
    email: "lungilev@email.com",
    location: "31 Carrot Patch, North West",
     image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Thabiso Pretorius",
    id: "FN02701001ABA123471",
    mobile: "+270702157015",
    email: "thabisop@email.com",
    location: "32 Onion Field, Eastern Cape",
    image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Nolwazi Steyn",
    id: "FN02701001ABA123472",
    mobile: "+270702157016",
    email: "nolwazis@email.com",
    location: "33 Cabbage Farm, KwaZulu-Natal",
      image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Siyabonga Jacobs",
    id: "FN02701001ABA123473",
    mobile: "+270702157017",
    email: "siyabongaj@email.com",
    location: "34 Spinach Plot, Northern Cape",
        image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Zinhle Van der Merwe",
    id: "FN02701001ABA123474",
    mobile: "+270702157018",
    email: "zinhlev@email.com",
    location: "35 Lettuce Garden, Gauteng",
     image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Mbali Smith",
    id: "FN02701001ABA123475",
    mobile: "+270702157019",
    email: "mbali@email.com",
    location: "36 Herb Farm, Western Cape",
        image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Thando Botha",
    id: "FN02701001ABA123476",
    mobile: "+270702157020",
    email: "thandob@email.com",
    location: "37 Pumpkin Patch, Limpopo",
      image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Sipho Van Wyk",
    id: "FN02701001ABA123477",
    mobile: "+270702157021",
    email: "siphov@email.com",
    location: "38 Maize Field, Mpumalanga",
      image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Nomsa De Klerk",
    id: "FN02701001ABA123478",
    mobile: "+270702157022",
    email: "nomsad@email.com",
    location: "39 Sunflower Farm, Free State",
        image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Bongani Coetzee",
    id: "FN02701001ABA123479",
    mobile: "+270702157023",
    email: "bongani@email.com",
    location: "40 Soybean Field, North West",
       image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Amahle Fourie",
    id: "FN02701001ABA123480",
    mobile: "+270702157024",
    email: "amahlef@email.com",
    location: "41 Canola Farm, Eastern Cape",
    image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Lerato Malan",
    id: "FN02701001ABA123481",
    mobile: "+270702157025",
    email: "leratom@email.com",
    location: "42 Wheat Farm, KwaZulu-Natal",
       image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "James Van Rensburg",
    id: "FN02701001ABA123482",
    mobile: "+270702157026",
    email: "jamesv@email.com",
    location: "43 Barley Field, Northern Cape",
        image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Nomvula Du Plessis",
    id: "FN02701001ABA123483",
    mobile: "+270702157027",
    email: "nomvulad@email.com",
    location: "44 Oat Farm, Gauteng",
      image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Sipho Lombard",
    id: "FN02701001ABA123484",
    mobile: "+270702157028",
    email: "siphol@email.com",
    location: "45 Rye Field, Western Cape",
       image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Thabiso Grobler",
    id: "FN02701001ABA123485",
    mobile: "+270702157029",
    email: "thabisog@email.com",
    location: "46 Sorghum Farm, Limpopo",
        image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Nthabiseng Marais",
    id: "FN02701001ABA123486",
    mobile: "+270702157030",
    email: "nthabisengm@email.com",
    location: "47 Millet Field, Mpumalanga",
        image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  },
  {
    name: "Kagiso Engelbrecht",
    id: "FN02701001ABA123487",
    mobile: "+270702157031",
    email: "kagisoe@email.com",
    location: "48 Quinoa Farm, Free State",
        image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752698725/Rectangle_34641748_qz0z5t.png"
  }
];

  
const Contract2th = () => {
    const [agreed, setAgreed] = useState(false);
    const renderButtonWithIcon = (text, bgColor, iconColor, isLarge = false) => {
      const bgColorClasses = {
        "#152C24": "bg-[#152C24]",
        "#2E453D": "bg-[#2E453D]",
        "#FDBB26": "bg-[#FDBB26]",
      };
  
      const iconColorClasses = {
        "#152C24": "bg-[#152C24]",
        "#2E453D": "bg-[#2E453D]",
        "#FDBB26": "bg-[#FDBB26]",
      };
  
      return (
        <div className="flex items-center">
          <div className={`${bgColorClasses[bgColor]} text-white md:text-[16px] text-[5px] px-2 md:px-4 ${
            isLarge ? "md:py-[14px] py-[3px]" : "md:py-[14px] py-[3px]"
          } md:rounded-l-md rounded-l-md font-bold w-[80px] md:w-[300px] whitespace-nowrap flex items-center h-full`}>
            {text}
          </div>
          
          <div className={`${iconColorClasses[iconColor]} hidden md:flex items-center md:py-2  justify-center md:w-[57px] md:h-[52px] rounded-r-md`}>
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
              alt="Expand"
              className="w-[20px] h-[6px] md:h-[40px] md:w-[55px]  object-contain"
            />
          </div>
          
          <div className={`${iconColorClasses[iconColor]} md:hidden flex items-center justify-center w-[20px]  h-[14px] rounded-r-md`}>
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
              alt="Expand"
              className="w-[20px] h-[6px]  object-contain"
            />
          </div>
        </div>
      );
    };

  const { selectedCountry } = useCountry();
  const [selectedService, setSelectedService] = useState(null);
  const [reportSelections, setReportSelections] = useState({
      COUNTRY: "-",
      REGION: "-",
      DISTRICT: "-",
      MUNICIPALITY: "-",
      SMMEs: "-",
      "VALUE CHAIN": "-",
      PROJECT: "-",
      "USER TYPE": "-"
  });

  const dropdownOptions = [
      { id: 1, name: "Option 1", value: "opt1" },
      { id: 2, name: "Option 2", value: "opt2" },
      { id: 3, name: "Option 3", value: "opt3" },
  ];

  const handleDropdownSelect = (option) => {
      console.log("Selected:", option);
  };

  return (
   <div className='bg-white'>
          <div className='md:px-20 px-4 md:pt-6 pt-2 md:pb-5 pb-2'>
              {/* Header Section */}
              <div className="flex flex-row justify-between items-start md:items-center gap-2 md:gap-0">
                  <h2 className="text-[14px] md:text-[36px] capitalize text-[#152C24] font-bold">
                      <span className="text-[#979797] capitalize">SERVICES | </span>{selectedCountry?.name || 'South Africa'}
                  </h2>
                  <div>
            <h1 className="md:text-[20px] text-[8px] font-extrabold md:mb-2">USER NUMBER</h1>
            <div className="flex w-fit">
              <button
                className={`xl:w-[250px] lg:w-[160px] md:w-[90px] w-[70px] h-[20px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}>
                <input className="md:text-[18px] text-[8px] md:px-2 bg-transparent outline-none placeholder-white" placeholder="XXXXXXXXX"/>
              </button>
              <div
                className="w-[16px] h-[20px] md:h-[53px] md:w-[50px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
              >
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
                  alt="expand"
                  className="w-3 h-[10px] md:w-6 md:h-[24px]"
                />
              </div>
            </div>
            <p className="md:text-[14px] text-[6px] font-normal mt-1 text-black">
              Insert ID Number
            </p>
          </div>
              </div>
              
              {/* Search Section */}
              <div className="flex items-center w-full md:mb-4 md:mt-6 mb-2 gap-4 md:gap-12">
             <div>
             <h1 className="md:text-[32px] font-bold text-[10px] text-[#979797]"  >Produce</h1>
             <Dropdown 
                      type="SERVICES" 
                      value={selectedService} 
                      onSelect={(option) => setSelectedService(option)}
                  />
                  
             </div>
                  <div className="flex-1 w-full relative  mt-2 md:mt-10">
                      <input
                          placeholder="Search"
                          type="text"
                          className="w-full h-[30px] md:h-[61px] text-[#979797] text-[10px] md:text-[16px] font-semibold p-2 pr-8 md:p-3 md:px-6 border border-[#C4C4C4] rounded-md focus:outline-none focus:ring-2 focus:ring-green-600"
                      />
                      <img
                          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744490602/Search_k7vxkr.png"
                          alt="Search Icon"
                          className="w-[14px] h-[14px] md:h-[24px] md:w-[24px] absolute right-3 top-1/2 transform -translate-y-1/2"
                      />
                  </div>
              </div>
              
              {/* Hero Banner */}
              <h2 className="text-[14px] md:text-[36px] capitalize text-[#152C24] font-bold">
                  Contracts
              </h2>
              
              <div className="relative w-full h-[150px] md:h-[650px] mt-2 md:mt-0">
                  <img
                      src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752696699/image_1846_askaal.png"
                      alt="Securing Agriculture in Namibia"
                      className="w-full h-full object-cover md:rounded-lg rounded-md transition-opacity duration-500"
                  />
              </div>
         
              {/* Content Section */}
              <h2 className="text-[14px] md:text-[36px] md:mt-6 mt-3 capitalize text-[#152C24] font-bold">
                  <span className="text-[#979797] capitalize">Cabbages | </span>African Marmalade
              </h2>
              <h2 className="text-[14px] md:text-[36px] md:mt-6 mt-3 capitalize text-[#152C24] font-bold">
              About contract
              </h2>
              <p className='text-[10px] md:text-[32px] font-medium md:mb-10 mb-4'>
              Cabbage contract farming is a formal agreement between farmers (producers) and buyers (processors, exporters, retailers, or agribusiness companies) where the farmer agrees to grow and supply cabbage under predefined conditions.
              </p>
              
              {/* Farmers Grid */}
              <div>
              <div className="grid grid-cols-4 md:grid-cols-4 gap-4 md:gap-8 my-6">
                      {[
                          {
                              title: "Price",
                              image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1752352068/image_1847_rbnehx.png",
                              description: "Competitive pricing models and payment terms"
                          },
                          {
                              title: "Quality",
                              image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1752352069/image_1852_nqj659.png",
                              description: "Quality standards and specifications"
                          },
                          {
                              title: "Delivery",
                              image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1752352069/image_1851_al3ilt.png",
                              description: "Delivery schedules and logistics"
                          },
                          {
                              title: "Inputs & Support",
                              image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1752352069/image_1853_kl9gku.png",
                              description: "Inputs provided and technical support"
                          }
                      ].map((item, index) => (
                          <div key={index} className="flex flex-col">
                              <h3 className="text-[10px] md:text-[36px] md:h-[60px] font-bold mb-2 md:mb-8 text-[#152C24]">
                                  {item.title}
                              </h3>
                              <div className="relative w-full h-[100px] md:h-[360px]  overflow-hidden mb-2">
                                  <img
                                      src={item.image}
                                      alt={item.title}
                                      className="w-full h-full object-cover"
                                  />
                              </div>
                              <div className="flex justify-end">
                                  <button 
                                      className="px-4 py-2 text-[8px] md:text-[16px] flex items-center gap-2 rounded-md transition-colors"
                                  >
                                      Download
                                      <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1749155706/Import_duotone_line_gjd1px.png" alt="download" className="w-[14px] h-[14px] md:w-[36px] md:h-[36px]"/>
                                  </button>
                              </div>
                          </div>
                      ))}
                  </div>
                  
                  
                  {/* OFFTAKE PARTNERSHIP AGREEMENT */}
                  <div className="mt-8">
                    <div className="flex items-center justify-between ">
                      <h2 className="text-[10px] md:text-[36px] font-bold text-[#152C24]">OFFTAKE PARTNERSHIP AGREEMENT</h2>
                      <a href="/ContractDocument">
                          <div>
                              {renderButtonWithIcon("Contract", "#2E453D", "#152C24", true)}
                              <p className="text-[6px] md:text-[14px] font-normal mt-1 text-black">
                              Click to update contract with details
                              </p>
                          </div>
                      </a>
                    </div>
                    <div className="md:w-[380px] w-[120px]  md:mt-5 mt-2 h-[30px] md:h-[51px] bg-[#2E453D] rounded-[5px] flex justify-end">
      <button className="md:w-[190px] w-[50px] h-full bg-[#2E453D] text-white text-[8px] md:text-[20px] font-bold rounded-[5px] z-10">
      Produce
      </button>
      <button className="md:w-[190px] w-[50px] text-[8px] font-bold md:text-[20px] h-full bg-[#152C24] text-white rounded-[5px] z-20">
      Cabbage
      </button>
    </div>
  <div className="md:mt-5 mt-3">
  <hr/>
  </div>
  <div className="font-sans md:text-[32px] text-[10px] leading-[1.6] text-black space-y-4 md:space-y-8 py-4 md:py-2">
    <p className="md:mt-6 mt-2">
      This Offtake Partnership Agreement ("Agreement") is made and entered into on this ___ day of ____________, 2025, by and between:
    </p>
    
    <p className="md:mt-6 mt-2">
      African Marmalade (Pty) Ltd, a company incorporated under the laws of South Africa, with its principal place of business at [Insert Address] (hereinafter referred to as the "Aggregator" or "African Marmalade"),
    </p>
    
    <p className="md:mt-6 mt-2">
      AND
    </p>
    
    <p className="md:mt-6 mt-2">
      The collective of member farmers affiliated with African Marmalade, represented jointly through African Marmalade and operating primarily in [Insert Region/Province], South Africa (hereinafter referred to as the "Farmers").
    </p>
    
    <p className="md:mt-6 mt-2">
      Each a "Party" and collectively referred to as the "Parties."
    </p>
    
    <div className="mt-8">
      <h3 className="font-bold">1. Purpose</h3>
      <p className="">
        This Agreement establishes a framework under which African Marmalade, as the appointed aggregator, will coordinate the supply of fresh agricultural produce from its member farmers to Bidvest Catering, a foodservice buyer. The goal is to ensure a consistent, high-quality, and traceable supply chain that benefits both the Farmers and Bidvest Catering.
      </p>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">2. Scope of Partnership</h3>
      <p className="">2.1 The Farmers, through African Marmalade, agree to cultivate and supply seasonal fresh produce, including but not limited to [insert types: e.g., leafy greens, root vegetables, tomatoes, herbs], as per schedules agreed with Bidvest Catering.</p>
      <p className="md:mt-6 mt-2">2.2 African Marmalade shall manage aggregation, quality assurance, logistics, and delivery of the produce to Bidvest Catering in accordance with the buyer's requirements.</p>
      <p className="md:mt-6 mt-2">2.3 All produce supplied shall meet the minimum quality, safety, and grading standards as defined in Schedule A.</p>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">3. Contractual Relationship with Bidvest Catering</h3>
      <p className="">3.1 African Marmalade shall act as the contracted supplier to Bidvest Catering, entering into a direct offtake agreement on behalf of its member farmers.</p>
      <p className="md:mt-6 mt-2">3.2 Member farmers agree that all produce destined for Bidvest Catering under this arrangement shall be coordinated and delivered exclusively through African Marmalade.</p>
      <p className="md:mt-6 mt-2">3.3 Farmers authorize African Marmalade to:</p>
      <ul className="space-y-4 md:mt-6 mt-2">
        <li>Aggregate volumes</li>
        <li>Negotiate pricing</li>
        <li>Manage payments</li>
        <li>Represent them in matters relating to the Bidvest contract</li>
      </ul>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">4. Purchase Commitment</h3>
      <p className="">4.1 African Marmalade (through its contract with Bidvest Catering) commits to purchasing agreed-upon volumes from the Farmers per harvest season.</p>
      <p className="md:mt-6 mt-2">4.2 Pricing shall be established in Schedule B, either as a fixed farmgate price or as a minimum guaranteed price plus a market-based bonus, where applicable.</p>
      <p className="md:mt-6 mt-2">4.3 Payments to farmers shall be made by African Marmalade within [Insert number] days of confirmed delivery, via [e.g., EFT or mobile money].</p>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">5. Obligations of the Farmers</h3>
      <p className="">The Farmers agree to:</p>
      <ul className="space-y-4 md:mt-6 mt-2">
        <li>Produce crops in accordance with agreed production plans and schedules</li>
        <li>Adhere to food safety and quality standards</li>
        <li>Participate in any training or audits coordinated by African Marmalade</li>
        <li>Notify African Marmalade of any production delays or risks</li>
      </ul>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">6. Obligations of African Marmalade</h3>
      <p className="">African Marmalade agrees to:</p>
      <ul className="space-y-4 md:mt-6 mt-2">
        <li>Serve as the exclusive aggregator and distributor of member farmers' produce to Bidvest Catering</li>
        <li>Provide logistical coordination, collection, and quality checks</li>
        <li>Disburse payments promptly and transparently</li>
        <li>Offer technical assistance or link farmers to support programs when feasible</li>
      </ul>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">7. Term and Termination</h3>
      <p className="">7.1 This Agreement shall remain in effect for a period of one (1) year from the Effective Date, unless renewed by mutual consent or terminated earlier.</p>
      <p className="md:mt-6 mt-2">7.2 Either Party may terminate this Agreement with 30 days' written notice, or immediately in the event of material breach.</p>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">8. Force Majeure</h3>
      <p className="">Neither Party shall be liable for non-performance due to circumstances beyond their control, including but not limited to natural disasters, strikes, pandemics, or regulatory restrictions.</p>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">9. Dispute Resolution</h3>
      <p className="">Disputes shall first be resolved through good-faith negotiations. If unresolved within 30 days, the dispute shall be referred to mediation or arbitration in accordance with the laws of South Africa.</p>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">10. Governing Law</h3>
      <p className="">This Agreement shall be governed by the laws of the Republic of South Africa.</p>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">11. Miscellaneous</h3>
      <ul className="space-y-8 md:mt-6 mt-2">
        <li>This Agreement constitutes the full understanding between the Parties.</li>
        <li>Amendments must be made in writing and signed by both Parties.</li>
        <li>Schedules A (Pricing Structure) and B (Quality Standards) form an integral part of this Agreement.</li>
      </ul>
    </div>
    
    <div className="mt-8">
   
      <p >
     <span className='font-bold'> IN WITNESS WHEREOF, </span>The Parties hereto have executed this Offtake Partnership Agreement as of the date first above written.
      </p>
    </div>
  </div>

  </div>
              </div>
              <div className="flex gap-4 items-center mt-5">
                          <div
                              className="md:w-16 md:h-[63px] w-6 h-[30px] rounded-[5px] bg-[#D9D9D9] flex items-center justify-center cursor-pointer transition"
                              onClick={() => {
                                  setAgreed((prev) => !prev);
                              }}
                              tabIndex={0}
                              aria-pressed={agreed}
                              aria-label="Confirm terms and conditions">
                              {/* Black or Green Check Round Fill SVG */}
                              {agreed ? (
                                  // GREEN CHECK ROUND FILL
                                  <svg
                                      width="54"
                                      height="54"
                                      viewBox="0 0 54 54"
                                      fill="none"
                                      className="md:w-[54px] md:h-[54px] w-[20px] h-[20px] transition-all duration-150"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle
                                          cx="27"
                                          cy="27"
                                          r="27"
                                          fill="#152C24"
                                      />
                                      <path
                                          d="M39 21L24.75 35L15 25.4545"
                                          stroke="white"
                                          strokeWidth="4"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                      />
                                  </svg>
                              ) : (
                                  // BLACK CHECK ROUND FILL
                                  <svg
                                      width="54"
                                      height="54"
                                      viewBox="0 0 54 54"
                                      fill="none"
                                      className="md:w-[54px] md:h-[54px] w-[20px] h-[20px] transition-all duration-150"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle
                                          cx="27"
                                          cy="27"
                                          r="27"
                                          fill="#222"
                                      />
                                      <path
                                          d="M39 21L24.75 35L15 25.4545"
                                          stroke="white"
                                          strokeWidth="4"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                      />
                                  </svg>
                              )}
                          </div>
                          <p className="md:text-[32px] text-[6px]">
                          About | Terms of Use | Privacy | Contact | © 2025 Farmers Networks
                          </p>

                   

                      {/* Text */}
                  </div>
                  <div className="flex justify-end md:gap-20   md:mt-8 mt-4">
                  <a href="/ContractDocument">
                      <div>
                          {renderButtonWithIcon("Issue Contract ", "#2E453D", "#152C24", true)}
                          <p className="md:text-[14px] text-[6px] font-normal mt-1">Click to  issue  and download contract </p>
                      </div>
                  </a>
                     <a href="/Contract4">
                      <div>
                          {renderButtonWithIcon("View Contracts", "#152C24", "#FDBB26", true)}
                          <p className="md:text-[14px] text-[6px] font-normal mt-1">Click to view contract</p>
                      </div>
                  </a>
              </div>
              <div className="flex justify-between items-center mt-6 md:mt-12">
            <div className="flex gap-1 md:gap-2 items-center">
              <h1 className="md:text-[24px] text-[8px] font-normal">Reviews & Ratings</h1>
              <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1752159820/image_1786_qgnngy.png" alt="link" className="w-[16px] h-[16px] md:w-[48px] md:h-[48px]"/>
            </div>
            <div className="flex gap-1 md:gap-2 items-center">
              <h1 className="md:text-[24px] text-[8px] font-normal">WhatsApp us</h1>
              <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1752160024/image_1785_bsrl4k.png" alt="link" className="w-[16px] h-[16px] md:w-[48px] md:h-[48px]"/>
            </div>
           </div>
              
             
          </div>
      </div>
  );
}

export default Contract2th;